<template>
  <div class="home-box">
    <a-back-top />
    <div class="home-head">
      <img src="../assets/logo.png" alt="">
      <ul>
        <li v-for="(item,i) in routerList" :key="i" :class="{active:item.default}" @click="()=>{
          routerList.forEach(items=>{
            items.default=false
          })
          item.default=true
        }">
          <router-link :to="item.link">{{item.name}}</router-link>
          <p class="home-head-line"></p>
        </li>
      </ul>
    </div>
    <div class="home-main">
      <router-view></router-view>
    </div>
    <div class="home-foot">
      <div class="home-foot-boxL">
        <div class="home-foot-boxLT">
          <img src="../assets/r1.png" alt="">
          <img src="../assets/r2.png" alt="">
          <img src="../assets/r3.png" alt="">

        </div>
        <div  class="home-foot-boxLB">
          <ul>
            <li v-for="(item,i) in footList" :key="i">
              <p>{{ item.name }}</p>
              <p v-for="(child,index) in item.children" :key="index">{{child}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="home-foot-boxR">
        <p>地址：湖北省武汉市洪山区青菱街道联东U谷生态科技产业园26栋</p>
        <p>电话：027-87103927</p>
        <p>邮箱：1226457695@163.com</p>
      </div>
    </div>
    <p style="border-top:1px solid #c8c8c8;padding:40px ;text-align:center;margin:0;letter-spacing: 2px;"><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #333">鄂ICP备 13017593号-2</a></p>
  </div>
</template>

<script>

export default {
  name: 'HomeView',
  data() {
    return {
      routerList:[{
        name:"首页",
        link:'/home',
        default:true
      },{
        name:"设备类产品",
        link:'/sb',
        default:false
      },{
        name:"耗材类产品",
        link:'/hc',
        default:false
      },{
        name:"关于我们",
        link:'/user',
        default:false
      }
    ],
    footList:[{
      name:"公司简介",
      children:['公司信息','发展历程','企业文化']
    },{
      name:"公司产品",
      children:['人工授精设备','人工授精耗材','畜牧小器械']
    },{
      name:"产品展示",
      children:['设备展示','耗材展示','器械展示']
    },{
      name:"联系我们",
      children:['电话：027-87103927','邮箱：1226457695@163.com']
    }]
    }
  },
  created(){
    
  },
  mounted() {
    this.routerList.map(v=>{
      v.default=v.link==location.pathname?true:false
    })
  },
  methods: {
    
  },
}
</script>
<style lang="scss" scoped>
$fff:#fff;
$col3:#333;
@mixin wid_hei($wid:100%,$hei:100%){
  width:$wid;
  height:$hei;
}
  .home-box{
    @include wid_hei();
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content:center;
   overflow-y: auto;
   overflow-x: hidden;
    .home-head{
      @include wid_hei(100%,60px);
      background: #1F1F1F;
      color: $fff;
      padding: 0 10%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      position: sticky;
      top:0;
      left:0;
      z-index:30000;
      &>img{
        height:60%;
      }
      &>ul{
        min-width: 40%;
        overflow:hidden;
        height: 100%;
        display: flex;
        align-items: center;
        margin-bottom:0;
        li{
          white-space: nowrap;
          color: $fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          height: 100%;
          line-height: 1;
          border-bottom:2px solid transparent;
          margin: 0 20px;
          padding-left:5px;
          position:relative;
          padding-top:10px;
          .home-head-line{
            height:2px;
            width:0;
            position:absolute;
            bottom:-2px;
            left:0;
            background: linear-gradient( 90deg, #0087C7 0%, #74C056 100%);
            margin-bottom:0;
          }
          &:hover p{
            animation: showLine 0.5s linear forwards;
          }
          a{
            letter-spacing: 5px;
            text-decoration: none;
            color: $fff;
            &:hover{
              color: $fff;
              background: #1F1F1F;
            }
          }
        }
        .active{
          border-bottom-color: $fff;
          &:hover p{
            animation:none;
          }
        }
      }
    }
    @keyframes showLine{
      0%{
        width: 0;
      }
      100%{
        width: 100%;
      }
    }
    .home-main{
      width:100%;
      background: $fff;
    }
    .home-foot{
      @include wid_hei(100%,370px);
      background: $fff;
      display: flex;
      align-items: center;
      justify-content:center;
      .home-foot-boxL{
        @include wid_hei(calc(100% - 415px),100%);
        overflow: hidden;
        border-right: 1px solid #C8C8C8;
        .home-foot-boxLT{
          @include wid_hei(100%,125px);
          height: 125px;
          border-bottom: 1px solid #C8C8C8;
          display: flex;
          align-items: center;
          justify-content: start;
          padding-left: 100px;
          &>img:nth-child(1){
            height: 80%;
          }
          &>img:nth-child(2){
            margin: 0 34px;
          }
          &>img:nth-child(3){
            height: 25%;
          }
        }
        .home-foot-boxLB{
          @include wid_hei(100%,calc(100% - 125px));
          display: flex;
          align-items: center;
          padding-left: 100px;
          ul{
            display: flex;
            justify-content: start;
            li{
              margin-right:30%;
              text-align: left;
              p:first-child{
                font-weight: 600;
                font-size: 18px;
                color: $col3;
                margin-bottom: 16px;
              }
              p{
                white-space:nowrap;
                font-weight: 400;
                font-size: 14px;
                color: #666;
                margin-bottom: 8px;
              }
            
            }
          }
        }
      }
      .home-foot-boxR{
        @include wid_hei(415px,100%);
        padding:0 48px;
        padding-top:125px;
        p{
          margin-bottom: 36px;
          color:$col3;
          text-align: left;
          font-size:14px;
          letter-spacing: 3px;
        }
      }
    }
  }
</style>
